module.exports = __webpack_public_path__ + "media/images/new/icons/home-89c2c388bde31b488931a5a8a1d0bca1.png";